import { ChartDataOptionsBuilder } from './chart-data-options-builder';
import {
  createDefaultChartDataOptionsBuilder,
  DefaultChartDataOptionsBuilder
} from './default-chart-data-options-builder';
import { FavouriteDataAdapter } from '../common/favourite-data-adapter';
import { FavouriteDataOptions } from '../common/favourite-data-options';
import { FavouriteRowValue } from '../common/favourite-interfaces';
import { DrillDownHandler } from '../common/drill-down-builder';
import { SeriesTypeColumnMappings } from 'app/components/favourite-layout/favourite/chart-data-options/types';
import { StackingOptions } from 'app/components/favourite-layout/constants';
import { YAxisOptions } from 'highcharts';
import { MIN_NO_OF_CRITERIAS } from 'app/area/reports/containers/chart/components/attributes/constants';

export class LineAndColumnChartDataOptionsBuilder implements ChartDataOptionsBuilder {
  private dataAdapter: FavouriteDataAdapter;
  private columnMappings: SeriesTypeColumnMappings = {
    mainSeries: {
      sel1: 'x',
      sel2: 'series',
      sel3: 'splitting',
      aggregation: 'y'
    },
    rollingAverageSeries: {
      sel1: 'x',
      sel2: 'series',
      sel3: 'splitting',
      aggregationRollAvg: 'y'
    },
    targetSeries: {
      sel1: 'x',
      sel2: 'series',
      sel3: 'splitting',
      target: 'y'
    }
  };

  private chartDataOptionsBuilder: DefaultChartDataOptionsBuilder;

  constructor(dataOptions: FavouriteDataOptions, dataAdapter: FavouriteDataAdapter, drillDownHandler: DrillDownHandler) {
    this.dataAdapter = dataAdapter;
    this.chartDataOptionsBuilder = createDefaultChartDataOptionsBuilder(dataOptions, dataAdapter, drillDownHandler, this.columnMappings);
  }

  public setOptions(options: Highcharts.Options, splitRow: FavouriteRowValue, seriesValues: FavouriteRowValue[]) {
    this.setStackingOptions(options);
    this.chartDataOptionsBuilder.hideSeriesIfUnsupportedAggrType(options);
    this.chartDataOptionsBuilder.setOptions(options, splitRow, seriesValues);
    this.setAxisLabels(options);
  }

  public colIndexOf(typeName: string, seriesType: string) {
    return this.chartDataOptionsBuilder.colIndexOf(typeName, seriesType);
  }

  public isXAxisReversedByDefault() {
    return this.chartDataOptionsBuilder.isXAxisReversedByDefault();
  }

  private setAxisLabels(options: Highcharts.Options) {
    if (this.chartDataOptionsBuilder.isBarColumnPercentEnabled()) {
      (options.yAxis as YAxisOptions).labels.formatter = undefined;
      (options.yAxis as YAxisOptions).labels.format = '{value}%';
    }
  }

  private setStackingOptions(options: Highcharts.Options) {
    options.plotOptions.column = options.plotOptions.column || {};
    const isPercentEnabled = this.chartDataOptionsBuilder.isBarColumnPercentEnabled();
    const isStackedEnabled = this.chartDataOptionsBuilder.isBarColumnStackedEnabled();
    const isMinNoOfCriterias = this.dataAdapter.selectionCount >= MIN_NO_OF_CRITERIAS;

    if (isStackedEnabled && isMinNoOfCriterias) {
      this.dataAdapter.showPercentageInTooltip = true;
    }

    // Set stacking in plotOptions base on chart layout attribute
    if (isStackedEnabled && isPercentEnabled) {
      options.plotOptions.column.stacking = StackingOptions.PERCENT;
    } else if (isStackedEnabled) {
      options.plotOptions.column.stacking = StackingOptions.NORMAL;
    } else {
      options.plotOptions.column.stacking = undefined;
    }
  }
}
